enum HttpStatus {
  OK = 200,
  NO_CONTENT = 204,

  PERMANENT_REDIRECTION = 301,
  FOUND_REDIRECTION = 302,

  BAD_REQUEST = 400,
  UNAUTHORIZED = 401,
  FORBIDDEN = 403,
  NOT_FOUND = 404,
  PRECONDITION_FAILED = 412,
  ENTITY_TOO_LARGE = 413,
  LOCKED = 423,
  FAILED_DEPENDENCY = 424,
  PRECONDITION_REQUIRED = 428,

  INTERNAL_SERVER_ERROR = 500,
  SERVICE_UNAVAILABLE = 503,
}

export default HttpStatus;
